module.exports = __webpack_public_path__ + "fonts/fontawesome/fa-duotone-900.ttf";